import styled from "styled-components";

export const InfoTitle = styled.div`
  background-color: var(--gray-color);
  border-radius: 10px;
  padding: .5rem .1rem;
  display: inline-block;
  width: 145px;

  p {
    margin: 0;
    color: #FFFFFF;
  }

  @media (max-width: 1200px) and (min-width: 992px){
    width: 115px;
    p {
      font-size: .9rem;
    }
  }
`;

export const MapWrapper = styled.div`
  border-radius: 10px;
  border: 1px solid rgba(118, 133, 155, 0.3);
  overflow: hidden;
  height: 250px;
`;

export const ShiftTimesSummary = styled.div`
  @media (max-width: 992px) {
    margin-top: -6rem;
    font-size: 1rem;
    
    span {
      font-size: .8rem;
      margin-top: .5rem;
    } 
  }
`;

export const InfoDesc = styled.div`
  background-color: #F5F6F9;
  padding: 1.3rem 2.5rem;
  border-radius: 10px;

  i::before {
      color: var(--sky-blue);
  }
  
  p {
    color: var(--dark-gray-color);

    &:last-child {
      margin: 0;
    }
  }
`;

export const CalenderItem = styled.div`
  text-align: center;
  border-radius: 10px;
  flex-basis: calc(100% / 7);
  //height: 110px;
  background-color: #F5F6F9;
  margin: 0 1rem;
  padding-top: .5rem;
  pointer-events: none;
  
  &::before {
    content: "";
    padding-top: 100%;  
  }
  
  p {
    margin: 0;
  }
  
  p:first-child {
    font-size: 1.2rem;
    color: var(--dark-gray-color);
  }
  
  p:last-child {
   font-size: 2.3rem;
   color: var(--gray-color)
  }
  
   &.active-date {
    background-color: var(--sky-blue);
    
    p {
    color: #FFFFFF;
    }
  }
  
  &:first-child {
    margin-right: 0;
  }
  
  &:last-child {
    margin-left: 0;
  }

  @media (max-width: 1200px) {
    min-width: 60px;
    max-width: 60px;
    min-height: 60px;
    max-height: 60px;

    p:first-child {
      font-size: .9rem;
    }

    p:last-child {
      font-size: 1.3rem;
    }
  }
  
  @media (max-width: 768px) {
    margin: 0;
    padding: 0 .2rem;
    min-width: 43px;
    max-width: 43px;
    min-height: 43px;
    max-height: 43px;
    
    p:first-child {
      font-size: .8rem;
    }

    p:last-child {
      font-size: 1rem;
    }
  }
  
`;

export const ShiftTimeContainer = styled.div`
  padding: .9rem 2.3rem;
  border-radius: 10px;
  
  p {
    color: #FFFFFF;
    margin: 0;
  }
`;

export const DaysRouteIcon = styled.div`
  left: 30px;
  position: absolute;
  transform: rotateZ(90deg);
  
  i::before {
    font-size: 8px;
    color: var(--sky-blue);
  }
`;
